import React from 'react';
import p from './phrases';
import * as e from '../elements';

export default {
  name: 'Benefit Image Left',
  description: 'Showcase benefits with accompanying images',
  thumb: 'benefit-image-left',
  tags: ['Benefit'],
  jsx: (
    <e.PBlock height="content" pad="md">
      <div className="row">
        <div className="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-0 text-center my-3">
          <e.PImage
            mediaUrlsafe="aghkZXZ-Tm9uZXIjCxIEVXNlchiAgICAgICACgwLEgVNZWRpYRiAgICAgPilCQw"
            renderSize="md" />
        </div>
        <div className="col-12 col-sm-10 offset-sm-1 col-md-6 offset-md-0 text-center text-md-left my-3">
          <e.PText className="my-3" color="primary" size="header-h3" text={p.benefitBlockTitle} />
          <e.PText className="my-3" color="black-lo" size="subheader-md" text={p.benefitBlockSlogan} />
          <e.PText
            className="my-3" color="black-md" size="text-md"
            text={p.benefitItemDescription}
          />
        </div>
      </div>
    </e.PBlock>
  ),
};



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/BenefitImageLeft.jsx